export default {
  content: {
    contactTitle: 'Visítanos',
    direction: 'Dirección',
    phone: 'Teléfonos',
    mail: 'Email',
    form: {
      name: 'Dinos tu nombre',
      frase: '<strong>¡Vamos con tu proyecto! </strong>',
      email: 'info@grupoapok.com',
      ubicacion: 'Venezuela',
      empresa: 'Mi Increíble Empresa',
      message: 'Cuéntanos un poco más...',
      submit: 'Enviar',
      cancel: 'Cancelar'
    },
    opciones: ['Una Web para tu negocio', 'Una App para cambiar el mundo', 'Un diseño destacado', 'Conversar un poco'],
    formularioComent: {
      title: 'Conversar un poco',
      pregunta0: '¿Cómo te llamamos?',
      pregunta1: '¿Cómo te contactamos?',
      pregunta2: '¿Dónde trabajas?',
      pregunta3: '¿De dónde nos escribes?',
      pregunta4: '¿Qué nos quieres contar?'
    },
    header: 'Sabemos que puedes tener muchas dudas.',
    headerDescription: '¿Es muy costoso hacer una aplicación? ¿Qué necesito para crear mi sitio web? <strong class=\'aqua\'>¿Por dónde empiezo?</strong> ¿Cómo sé cuál tecnología es la mejor?',
    bodyFrase: 'No te preocupes,',
    bodyFrase1: 'responderemos cada pregunta',
    fraseCafe: '<strong>¡Hacemos un café buenísimo!</strong>',
    aboutFrase: '<strong>Te gustaría conversar sobre...</strong>',
    textHeader: 'CONTÁCTANOS',
    textFooter: 'Responderemos todas tus dudas y te ayudaremos en cada paso de tu proyecto',
    urgente: '¿Es Urgente?',
    tiempo: ['¡¡¡Para ayer!!!', 'Algo ajustado de tiempo', 'No hay apuro'],
    agregar: '¿Algo más que agregar?',
    web: {
      title: '¡Una Web para tu negocio!',
      pregunta4: '¿En qué tipo de Web estás interesado?',
      hint: 'Tipo de web',
      tipo: ['Personal', 'Corporativa', 'Ecommerce', 'Multimedia']
    },
    app: {
      title: 'Una App para cambiar el mundo',
      pregunta4: '¿En qué tipo de App estás interesado?',
      hint: 'Tipo de App',
      tipo: ['Personal', 'Corporativa', 'Ecommerce', 'Multimedia']
    },
    dise: {
      title: 'Un diseño destacado',
      pregunta4: '¿En qué tipo de diseño estás interesado?',
      hint: 'Tipo de Diseño',
      tipo: ['Imagen', 'Publicidad', 'Interfaces para Apps o Web']
    },
    agradecimientos: {
      titulo: 'Gracias por escribirnos.',
      text: 'Para una atención más personalizada sugerimos acordar una reunión online o incluso puedes visitar nuestras oficinas.'
    },
    selector: 'Selecciona un tema...',
    botonAtras: 'Volver',
    findUsIn: 'Encuéntranos en:',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/es/contact.js